/**
 * @generated SignedSource<<88204cdaf2ae7da8d0e6b79c231209b0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type printOSLoginTokenQuery$variables = {
  data: string;
};
export type printOSLoginTokenQuery$data = {
  readonly auth: string;
};
export type printOSLoginTokenQuery = {
  response: printOSLoginTokenQuery$data;
  variables: printOSLoginTokenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "data"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "kind": "ScalarField",
    "name": "auth",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "printOSLoginTokenQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "printOSLoginTokenQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "c58019c0a9fb43336707bcce7a70197b",
    "id": null,
    "metadata": {},
    "name": "printOSLoginTokenQuery",
    "operationKind": "query",
    "text": "query printOSLoginTokenQuery(\n  $data: String!\n) {\n  auth(data: $data)\n}\n"
  }
};
})();

(node as any).hash = "e16155c0751f2a7101a40e0963dd5263";

export default node;
